export default __webpack_public_path__ + "images/e3dfeb2c95f5e9b347fb47cd045004b0-video-thumbnail.webp";